const segments = [
  /* {
    id: '',
    headline: '',
    description: '',
    img: '',
    buttons: [
      {
        title: '',
        href: '',
      },
    ],
    width: 12,
  },
  */
  {
    id: 'itera',
    headline: 'Wood',
    description: 'Model Klaus is a wooden stool. It carries the believe, that products must give their owners moments of peace and that not everything needs to have a digital component. What originally started by spending some time in a 	carpentry became an iterior design product - with the fantastic help of Malte Windwehr and Deniz Aksoy, of course. The core message of Model Klaus is pretty straight forward: Calm down.',
    img: '/img/itera_header.jpg',
    buttons: [
      {
        title: 'Get to know Klaus',
        href: 'https://www.einhocker.de/en/home',
      },
    ],
    width: 12,
  },
  {
    id: 'mm',
    headline: 'git commit -m \'❤️\'',
    description: 'In 2015, I joined Mimi Hearing Technologies as a developer focussing on iOS and React.js. It’s been an amazing three years. We completely rewrote the iOS flagship product from scratch, which reached 1,000,000 downloads in August 2018 with an average review of 4.6 out of 5 stars. Another highlight was developing the first web-based hearing test. Most importantly, though: It’s where I joined team Vim.',
    img: '/img/mm_header.jpg',
    buttons: [
      {
        title: 'Take hearing test',
        href: 'https://hearingtest.mimi.io',
      },
      {
        title: 'Check out Mimi',
        href: 'https://www.mimi.io',
      },
    ],
    width: 6,
  },
  {
    id: 'hi',
    headline: 'Time for Code',
    description: 'Some call Hyper Island the digital Harvard. I’d like to think of it more as a space for personal growth. Completing the ‘mobile design and development’ program in Stockholm, gave me that space to focus on coding for a whole year. Alongside it taught me how to facilitate team development processes.',
    img: '/img/hi_header.jpg',
    buttons: [
      {
        title: 'See website',
        href: 'https://www.hyperisland.com',
      },
    ],
    width: 6,
  },
  {
    id: 'rs',
    headline: 'I Am a Keyboard',
    description: 'USB is great. It\'s simple and reliable. Until that thing above pretends to be a keyboard, automatically opens up a terminal when plugged in and creates a cronjob that connects to a server every now and then. Giving the attacker access via a reverse shell. Just. Like. That. I couldn\'t believe it and had to build it myself. Checkout the repository with code running on the device and on the server it connects to.',
    img: '/img/rs_header.jpg',
    buttons: [
      {
        title: 'Github Repo',
        href: 'https://github.com/maxstralka/reverse-shell',
      },
    ],
    width: 6,
  },
  {
    id: 'lists',
    headline: 'Opposites Attract',
    description: 'Supposingly, Bash commands and design resources are two topics, that just couldn\'t be any more different. At one point, I started making a list for each and thought I put them in Medium articles. Who knows, maybe it helps someone. My personal favorite? This quote by Dieter Rams (Vitsœ): "Good design is as little design as possible"',
    img: '/img/lists_header.jpg',
    buttons: [
      {
        title: 'Design resources',
        href: 'https://medium.com/@maximilian.stralka/mobile-design-ressources-6e052fc07eea',
      },
      {
        title: 'Bash commands',
        href: 'https://medium.com/@maximilian.stralka/collection-of-bash-commands-57d171f41b6c',
      },
    ],
    width: 6,
  },
  /*{
    id: 'tomorrowSunshine',
    headline: 'The sunny side',
    description: 'Must have been one day of rain too much in Berlin. To keep up hope, I built tomorrowsunshine.com, which queries for places where the sun shines tomorrow and looks up flights to get there.',
    img: '/img/ts_header.jpg',
    buttons: [
      {
        title: 'Have a look',
        href: 'http://tomorrowsunshine.com',
      },
    ],
    width: 6,
  }, */
  {
    id: 'stilleBilder',
    headline: 'Images with Life',
    description: 'Stillebilder.com is a rather experimental project. The idea was to create images that have small elements within them move or happen. But in a manner, that the whole thing would still appear as an image - not a video. Eventually the person looking at the image, gets a richer experience compared to a regular picture.',
    video: '/videos/stillebilder_4846.mp4',
    buttons: [
      {
        title: 'stillebilder.com',
        href: 'http://stillebilder.com',
      },
    ],
    width: 12,
  },
  {
    id: 'ppl',
    headline: 'Climbing 3500ft',
    description: 'It\'s still not quite clear to me, where the urge came from to do a private pilot licence on the side. Might have been the intrinsic need for contineous learning, the thrill of actually flying a Cessna or just pure curiousity. The training (PPL-A EASA-FCL) took almost two years. I completed it in July 2018.',
    video: '/videos/ppl_header.mp4',
    width: 6,
  },
  {
    id: 'it_security',
    headline: 'Breaking IT',
    description: 'Pretty much everyone talks about security in tech these days. I wanted to learn how to actually break things and spent eight weeks studying the most commen attack procedures. I shared my notes in a medium article.',
    img: '/img/it_header.jpg',
    buttons: [
      {
        title: 'Read notes',
        href: 'https://medium.com/@maximilian.stralka/i-spend-8-weeks-on-it-security-heres-my-notes-3df9a2cc3511',
      },
    ],
    width: 6,
  },
  {
    id: 'emoji',
    headline: '3D Animation',
    description: 'I supported Stockholm based development agency \'In Love With\' by creating two teaser videos for their apps \'Emoji my face\' and \'Keep Delete\'. The goal was to learn more about how to best do animations in Adobe After Effects. This was an opportunity to get deeper into 3D modeling and animation of objects - in this case a phone - within a video.',
    img: '/img/emoji_header.jpg',
    buttons: [
      {
        title: 'Emoji my face video',
        href: 'https://vimeo.com/130113971',
      },
      {
        title: 'KeepDelete video',
        href: 'https://vimeo.com/130112888',
      },
    ],
    width: 6,
  },
  {
    id: 'cs',
    headline: 'Digital education',
    description: 'Cornelsen is the second largest school book publisher in Germany. Once a year it selects bright minds from education, design and tech to challenge them for two days with one question: "What\'s next in the field of digital education?"  My part: Design thinking method coach and workshop facilitation.',
    img: '/img/cs_header.jpg',
    buttons: [],
    width: 6,
  },
  {
    id: 'gega',
    headline: 'Heros, Companionship And A Glimpse Of Madness',
    description: 'When it comes to creating innovative steel cutting machinery, GeGa Group is global market leader. The brief was clear: Relaunch the brand to better reach the core audience and start executing right away. A deep customer analysis led to a clear repositioning of the GeGa brand and media production was started immediately.',
    img: '/img/gg_header.jpg',
    buttons: [],
    width: 12,
  },
  {
    id: 'kukimi',
    headline: 'Eat. Sleep. Repeat.',
    description: 'There are people in this world that love to cook. For those who don\'t and still want to eat healthy, web start-up Kukimi comes to the rescue. My role with Kukimi: Co-Founder and Entrepreneur in Residence through Atlantic Internet, a seed-investment vehicle led by Christophe Maire.',
    img: 'img/kk_header.jpg',
    buttons: [
      {
        title: 'Visit Kukimi',
        href: 'https://kukimi.de',
      },
      {
        title: 'Visit Atlantic Labs',
        href: 'https://www.atlanticlabs.de',
      },
    ],
    width: 6,
  },
  {
    id: 'alabin',
    headline: 'Just Build It',
    description: 'Alabin is an open source project, led by curiosity and the urge to learn hardware prototyping. It is based on an Arduino, an omnidirectional barcode scanner, a GSM-Shield and an awesome summer in Berlin with Mr. Philipp Skribanowitz.',
    img: 'img/a_header.jpg',
    buttons: [
      {
        title: 'Go to Alabin.de',
        href: 'http://alabin.de',
      },
    ],
    width: 6,
  },
  {
    id: 'jvm',
    headline: 'Ads',
    description: 'Back in the days, I was as a copywriter at Jung von Matt/Elbe. With my team, I won a bronze Art Directors Club (ADC) Nail, another award at VISUAL LEADERS and was shortlisted at the Golden Award of Montreux. Whew! I left the agency after my six month internship.',
    img: 'img/jvm_header.jpg',
    buttons: [
      {
        title: 'See Print Ad',
        href: 'http://www.adeevee.com/2008/09/konzerthaus-dortmund-music-for-everyone-print',
      }
    ],
    width: 12,
  },
  {
    id: 'db',
    headline: 'Bankers and Design Thinking?',
    description: 'Once a year Deutsche Bank does something unexpected: The giant invites creative talent into their halls to solve a specific problem within the banking industry. I was part of this project in 2012. It took six month, was based on Design Thinking as core innovation method and coached by St. Gallen University and Stanford University',
    img: 'img/db_header.jpg',
    buttons: [
      {
        title: 'Watch Videos',
        href: 'https://www.youtube.com/watch?v=ustMjzmL1e0',
      },
    ],
    width: 6,
  },
  {
    id: 'edward',
    headline: 'A machine called Edward',
    description: 'My mate Malte Windwehr and I invented Edward. Best live communication tool on earth? Ok, photo booth - on crack! Results are displayed throughout event venues, uploaded onto dedicated microsites or printed and framed - all within the blink of an eye, right on location. We took him to fashion shows, industry gatherings, weddings, bunker parties - and your mom\'s place.',
    img: 'img/em_header.jpg',
    buttons: [],
    width: 6,
  },
  {
    id: 'energyIsland',
    headline: 'Experiencing Renewable Energies',
    description: 'Energy Island is based on the conviction that for people to \'get\' stuff, they need to \'touch\' it . We worked on a concept for children and adults alike to \'get\' renewable energies. The idea was to upcycle a decomissioned ferry boat at Lake Constance and turn it into a floating experimentation and learning platform, running entirely on green tech. Hey, we won two national awards with this stuff!',
    img: 'img/ei_header.jpg',
    buttons: [
      {
        title: 'Go to energyisland.de',
        href: 'http://www.energyisland.de',
      },
    ],
    width: 12,
  },
  {
    id: 'zu',
    headline: 'Get your daily dose',
    description: 'Zeppelin University (ZU) aims to provide a broad perspective on social, political and economic topics. The intention of ZU-Daily: Make scientific insights available and understandable to non-university readers. I supported the Team with Design Thinking Workshops.',
    img: 'img/zu_header.jpg',
    buttons: [
      {
        title: 'See zu-daily',
        href: 'https://www.zu-daily.de',
      },
    ],
    width: 6,
  },
  {
    id: 'mtv',
    headline: 'Welcome to the MTV News',
    description: 'I spent some time at MTV Berlin as an editor with their news division - the News Mag. I worked with Markus Kavka and had a ball. The show was discontinued in 2010. What can I say.',
    img: 'img/mtv_header.jpg',
    buttons: [],
    width: 6,
  },
  {
    id: 'contact',
    intro: 'Contact',
    headline: 'Lame Puns',
    description: 'I guess, the wild internet lands are my playgrounds. If you want to learn more about my work in software engineering, design thinking and team development facilitation, get in touch. I am currently based in Berlin.',
    img: 'img/ms_header.jpg',
    buttons: [
      {
        title: 'Send mail',
        href: 'mailto:maxstralka@me.com',
      },
      {
        title: 'Twitter',
        href: 'https://twitter.com/maxstralka',
      },
    ],
    width: 12,
  },
];

export default segments;



// WEBPACK FOOTER //
// ./src/content/content.js